import React from 'react';
import ReactDOM from 'react-dom';
import App from './Routes';
import './bootstrap.css'

ReactDOM.render(<App />, document.getElementById('root'));
